import type { FC, ReactElement } from "react"

import eq from "lodash-es/eq"

import { ETypographyColor, ETypographySize, ETypographyWeight, Typography } from "@/3514/components"
import { type IUseTranslation, useTranslation } from "@/hooks"

import { useCoachingChatContext as useChatContext } from "../context"
import { useCoachingChatConversationStatusSelector as useConversationStatusSelector } from "../store"
import { coachingChatStyles as chatStyles } from "../styles"
import { ECoachingChatConversationStatus as EConversationStatus } from "../types"

const {
    conversation: { closedIndicator: classes }
} = chatStyles

const Indicator: FC = (): ReactElement => {
    const { t }: IUseTranslation = useTranslation()

    const { entityId }: ReturnType<typeof useChatContext> = useChatContext()

    const status: EConversationStatus = useConversationStatusSelector(entityId)

    const isVisible: boolean =
        eq(status, EConversationStatus.Completed) || eq(status, EConversationStatus.GeneratingSummary)

    return (
        <div className={classes.container(isVisible)}>
            <hr className={classes.hr()} />
            <Typography
                text={t("entities.coachingChat.chat.chatClosedMessage")}
                color={ETypographyColor.White}
                size={ETypographySize.ExtraSmall}
                weight={ETypographyWeight.Bold}
                className={classes.text()}
            />
            <hr className={classes.hr()} />
        </div>
    )
}

Indicator.displayName = "CoachingChatClosedIndicator"

export { Indicator as CoachingChatClosedIndicator }
